import TableRows from "./table-rows";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from '@mui/icons-material/Add';

function AddDeleteTableRows({
  modelDropDownOptions,
  selectedCamera,
  rowsData,
  addTableRows,
  deleteTableRows,
  handleAlertStartTimeChange,
  handleAlertEndTimeChange,
  handlePointsChange,
  handleDetectionTypeChange,
  handleSelectRowChange,
  handleDirectionChange,
  handleFullRegionTypeChange,
  setModelCriteria,
  handleDistanceChange,
  handleShowAllChange
}) {
  console.log(rowsData)
  return (
    <div className="text-white">
      <div className="row w-100 m-1">
        <div className="w-100 table-box p-1" style={{ transform: "scale(1)" }}>
          <table className="table">
            <thead style={{fontSize: "larger", backgroundColor: '#102747'}}>
              <tr>
                <th>select</th>
                <th>Assign</th>
                <th>Detection Type</th>
                <th>Action</th>
                <th>Alert Time</th>
                <th>
                  <button
                    className="add m-0"
                    onClick={addTableRows}
                    disabled={selectedCamera ? false : true}
                  >
                    <AddIcon fontSize="small" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <TableRows
                modelDropDownOptions={modelDropDownOptions}
                rowsData={rowsData}
                deleteTableRows={deleteTableRows}
                handleAlertStartTimeChange={handleAlertStartTimeChange}
                handleAlertEndTimeChange={handleAlertEndTimeChange}
                handlePointsChange={handlePointsChange}
                handleDetectionTypeChange={handleDetectionTypeChange}
                handleSelectRowChange={handleSelectRowChange}
                handleDirectionChange={handleDirectionChange}
                handleFullRegionTypeChange={handleFullRegionTypeChange}
                setModelCriteria={setModelCriteria}
                handleDistanceChange={handleDistanceChange}
                handleShowAllChange={handleShowAllChange}
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AddDeleteTableRows;